var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCancel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.7419 23.5986C38.7319 18.4286 34.5719 14.2686 29.3919 13.2586C20.8919 11.6086 13.4619 18.0786 13.4619 26.2686H8.83191C8.08191 26.2686 7.72191 27.1686 8.25191 27.6786L14.5319 33.9786C14.8619 34.3086 15.3819 34.3086 15.7119 33.9786L21.9919 27.6986C22.5019 27.1686 22.1419 26.2686 21.3919 26.2686H16.7619C16.7619 20.0886 22.4319 15.1886 28.8519 16.5486C32.6119 17.3286 35.6519 20.3786 36.4319 24.1286C37.0319 26.9686 36.3919 29.6686 34.9719 31.7786C34.7719 32.0486 34.6519 32.3886 34.6519 32.7486C34.6519 33.6686 35.4019 34.4186 36.3219 34.4186C36.9419 34.4186 37.4719 34.0786 37.7619 33.5886C39.5819 30.8186 40.4419 27.2786 39.7219 23.5786L39.7419 23.5986Z",
    fill: "#FFF7EB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancel);
export default __webpack_public_path__ + "static/media/cancel.3bde9330eac570ab98b67b9d591cf728.svg";
export { ForwardRef as ReactComponent };